import React from "react";
import { Modal, Button } from "antd";

export default function UserModal(props) {
  const { visible, ModalHeader } = props;
  return (
    <Modal
      visible={visible}
      title={ModalHeader}
      onOk={() => {}}
      onCancel={() => {
        props.openModal(false);
      }}
      footer={[
        <Button
          type="primary"
          // loading={loading}
          onClick={() => {
            props.openModal(false);
          }}
        >
          Got it
        </Button>,
      ]}
    >
      <p>
        Please check your inbox (ramy.nour@gmail.com) and click on the
        verification link to verify your email.
      </p>
    </Modal>
  );
}
